import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./linktree-page/linktree-page.component').then(m => m.LinktreePageComponent),
      },
      {
        path: 'services',
        loadComponent: () =>
          import('./services-page/services-page.component').then(m => m.ServicesPageComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
